import React, { useEffect, useState } from 'react';
import { GlobalLoader } from './GlobalLoader';

export const DelayedLoader: React.FC<{ delay?: number }> = ({ delay = 150 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return visible ? <GlobalLoader /> : null;
};
